export enum LoyaltyProgramId {
    EurobankEpistrofi = 1,
    NbgGo4More = 2,
    AlphaLoyalty = 3
}
